<template>
    <div id="development">
        <div class="top">
            <img src="../../assets/images/icon-address-2.png" alt="">
        </div>
        <div class="box">
            <div class="item" v-for="(item,index) in detail" :key="item.id" :class="{'right':index%2!==0}">
                <div class="message">
                    <p>{{item.date}}</p>
                    <p>{{item.content}}</p>
                </div>
                <div class="circle">
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Development",
        data(){
            return{
                detail:[]
            }
        },
        methods:{
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.detail = JSON.parse(res.data.msg.navigationBars[1].navigationSubmenus[1].content);
                        
                    }
                })
            },
        },
        created() {
            this.getNav();
        }
    }
</script>

<style scoped lang="less">
#development{
    margin-top: 30px;
    .top{
        text-align: center;
        img{
            width: 32px;
            height: 36px;
        }
    }
    .box{
        position: relative;
        margin-top: 10px;
        overflow: hidden;
        &::before{
            content: '';
            height: 100%;
            width: 1px;
            background-color: #D8D8D8;
            left: 50%;
            margin-left: -0.5px;
            position: absolute;
        }
        .item{
            display: inline-block;
            position: relative;
            width: 51%;
            margin-top: -67px;
            &:first-child{
                margin-top: 0;
            }
            &+.left{
                float: left;
            }
            &+.right{
                float: right;
                .message{
                    margin-left: 40px;
                    &::after{
                        left: -11px;
                        border-top: none;
                        border-right: none;
                        border-bottom: 1px solid #D8D8D8;
                        border-left: 1px solid #D8D8D8;
                    }
                }
                .circle{
                    left: 3px;
                }
            }
            .message{
                margin: 20px;
                padding: 20px;
                margin-right: 40px;
                border-radius: 10px;
                border: 1px solid #D8D8D8;
                position: relative;
                &::after{
                    content: '';
                    width: 20px;
                    height: 20px;
                    border-top: 1px solid #D8D8D8;
                    border-right: 1px solid #D8D8D8;
                    background-color: #ffffff;
                    position: absolute;
                    right: -11px;
                    top: 50%;
                    margin-top: -10px;
                    transform: rotate(45deg);
                }
                p{
                    color: #181818;
                    &:nth-child(1){
                        font-size: 16px;
                    }
                    &:nth-child(2){
                        font-size: 14px;
                        margin-top: 14px;
                    }
                }
            }
            .circle{
                position: absolute;
                width: 14px;
                height: 14px;
                background-color: #64EDAC;
                border-radius: 50%;
                right: 3px;
                top: 50%;
                margin-top: -7px;
                display: flex;
                align-items: center;
                justify-content: center;
                div{
                    background-color: #307C48;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                }
            }
        }
    }
}
</style>
